<template>
<div class="tinder-wrapper">
    <div class="knd-match" v-if="match">
      <div class="knd-match__bg"></div>
      <div class="knd-match__inner">
        <div class="knd-match__header">
          <img class="knd-match__icon" src="@/assets/icons/match.svg" />
        </div>

        <div class="knd-match__person">
          <div style="width: 100%;position: absolute;left: 50%;transform: translateX(-50%);">
            <img class="knd-match__icon knd-match__heart" src="@/assets/icons/match-heart.svg" />
            <img class="knd-match__icon knd-match__avatar" :src="'https://pointer-dev.kro-ncrv.nl/' + $store.state.match.avatar" />
          </div>
        </div>

        <div class="knd-wrapper knd-match__login">
            <h5>Je hebt een match met {{$store.state.match.name}}!</h5> 
            <p>Maak een account om te starten met chatten.</p> 
            <Login />
        </div>


        <!-- <div class="knd-match__scroll">
          <svg class='knd-animate-bounce' width="27" height="29" viewBox="0 0 27 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path  d="M11.7692 24.0488L11.7692 -1.51314e-06L15.2308 -1.16925e-06L15.2308 24.0488C16.0615 21.9268 17.4462 20.0642 19.3846 18.461C21.3231 16.8577 23.8615 15.8911 27 15.561L27 19.0976C24.0923 19.4276 21.6 20.5594 19.5231 22.4927C17.4462 24.4732 16.0154 26.6423 15.2308 29L11.7692 29C10.9846 26.6423 9.55384 24.4732 7.47692 22.4927C5.4 20.5593 2.90769 19.4276 -1.8973e-06 19.0976L-1.54595e-06 15.561C3.13846 15.8911 5.67692 16.8577 7.61538 18.461C9.55384 20.0642 10.9385 21.9268 11.7692 24.0488Z" fill="black"/>
            </svg>
        </div> -->
      </div>
    </div>

      <div :class="{'has-match': match}" class="tinder-wrapper">
        <div class="knd-wrapper knd-my-5">
          <h5 class="knd-tinder__title knd-text-center">
            Kies hier jouw droomman of -vrouw
          </h5>
          <p class="knd-text-center">
            Swipe naar links om af te wijzen, naar rechts om te selecteren
          </p>
        </div>
        <Tinder
          ref="tinder"
          key-name="key"
          v-model:queue="queue"
          :max="3"
          :offset-y="10"
          @submit="onSubmit"
        >
          <template #default="{ data }">
            <div
              class="pic"
              :style="{
                'background-image': `url(https://pointer-dev.kro-ncrv.nl/${data.url})`
              }"
            ></div>

          </template>
          <template #like>
            <img class="like-pointer" src="@/assets/icons/heart.svg" />
          </template>
          <template #nope>
            <img class="nope-pointer" src="@/assets/icons/reject.svg" />
          </template>
        </Tinder>
      </div>
    </div>

      <div class="btns" v-if="!match">
        <img class="pointer" src="@/assets/icons/reject.svg" @click="decide('nope')"/>
        <img class="pointer" src="@/assets/icons/heart.svg" @click="decide('like')" />
      </div>
</template>

<script>
import Tinder from 'vue-tinder'
import 'vue-tinder/lib/style.css'

import Login from './login.vue';

  export default {
    components: { Tinder, Login },
    data: () => ({
    queue: [],
    offset: 0,
    history: [],
    match: false,
    intervalId: undefined,
    totalOffset: 0
  }),
  created() {
    this.mock()
  },
  computed: {
    profielen() {
      return this.$store.state.profielen;
    }
  },   
  mounted() {
    let options = [
        {value:'nope'}, 
        // {value: 'like'}, 
    ];

    let count = 0;

    let el = document.querySelector('.vue-tinder');
    if(el) {
      const height = el.offsetHeight;
      el.style.width = height * 0.70 + 'px'; 
    }

    this.intervalId = window.setInterval(() => {
      if(!this.$refs.tinder) return;
        let num = Math.floor(Math.random() * options.length)
        this.$refs.tinder.decide(options[num].value);
        count += 1;
        if(count >= 2 ) {
          window.clearInterval(this.intervalId);
        }
    }, 3000);
  },
  methods: {
    mock(count = 5, append = true) {
      const list = []

      for (let i = 0; i < count; i++) {
        if(this.offset >= this.profielen.length) {
          this.offset = 0;
        }

        list.push({ 
          key: 'name' + this.totalOffset, 
          url: this.profielen[this.offset].afbeelding[0].url,
          name: this.profielen[this.offset].naam,
          werk: this.profielen[this.offset].werk,
          avatar: this.profielen[this.offset].afbeelding_klein[0].url,
        })
        this.offset++
        this.totalOffset++;
      }
      if (append) {
        this.queue = this.queue.concat(list)
      } else {
        this.queue.unshift(...list)
      }
    },

    onSubmit({ type, item }) {
      if (this.queue.length < this.profielen.length) {
        this.mock()
      }

      this.history.push(item);

      if(type === 'like') {
        this.thisOne();
      }

    },

    thisOne() {

      let item = this.history[this.history.length -1];
      let name = item.name;
      let avatar = item.avatar;
      let werk = item.werk;

      this.$store.dispatch(
        'matchMade',
        { 
          name: name, 
          avatar: avatar,
          werk: werk
        }
      )

      this.match = true;
      clearInterval(this.intervalId);
    },

    async decide(choice) {
      if (choice === 'rewind') {
        if (this.history.length) {
          this.$refs.tinder.rewind(
            this.history.splice(-Math.ceil(Math.random() * 3))
          )
        }
      } else {
        this.$refs.tinder.decide(choice);
        if(choice === 'like'){
          this.thisOne(); 
        }
      }
    }
  }
    }
</script>

<style lang="scss" scoped>
.vue-tinder {
  position: absolute !important;
  z-index: 1;
  left: 0;
  right: 0;
  top: 120px;
  margin: auto;
  width: calc(100% - 20px);
  height: calc(100% - 23px - 65px - 47px - 150px);
  min-width: 300px;
  max-width: 355px;
  min-height: 350px;
}

.tinder-wrapper {
  // animation-duration: 1.2s;
  // animation-delay: 4s;
  // animation-name: hide;
  // animation-fill-mode: forwards;  
}

.knd-tinder__title {
  margin-top: 30px;
  margin-bottom: 0;
}

.knd-match {
  transition: all .5s;
  z-index: 100;

  // min-height: 100vh;
  height: 100vh;
  width: 100vw;
  position: absolute;

  .knd-match__bg {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: theme('colors.red.DEFAULT');

    transform: translate(-50%, -50%);
    
    animation-duration: .5s;
    animation-name: bigger;
    animation-fill-mode: forwards;  
  }

  .knd-match__login {
    position: relative;
    text-align: center;
    opacity: 0;
    animation-duration: .5s;
    animation-delay: 2s;
    animation-name: fade-in;
    animation-fill-mode: forwards;  

  }
  
  .knd-match__header {
    height: 30%;
  }

  .knd-match__scroll {
    height: 30%;
    display: flex;

    svg {
      margin: 0 auto;
      align-self: flex-end;
    }
  }
}

@keyframes hide {
  to {
    width: 0;
    height: 0;
    overflow:hidden;
    min-height: 0;
    transform: scale(0);
  }
}

@keyframes bigger {
  to {
    width: 150vh;
    height: 150vh;
  } 
}

@keyframes fade-in {
  to {
    opacity: 1;
  } 
}

.knd-match__inner {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}

.knd-match__header {
  opacity: 0;
  animation-duration: .6s;
  animation-delay: .8s;
  animation-name: show;
  animation-fill-mode: forwards;  
}

.knd-match__avatar, .knd-match__heart {
  opacity: 0;
  animation-duration: .6s;
  animation-delay: 1.2s;
  animation-name: show;
  animation-fill-mode: forwards;  
}

.knd-match__heart {
  animation-delay: 1.5s;

}

@keyframes show {
  0% {
    opacity: 0;
    transform: scale(0);
  }

  50% {
    opacity: 1;
    transform: scale(1.5);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.knd-match__icon {
  margin: 0 auto;
  max-width: auto;
  height: 100%;
}

.knd-match__person {
  position: relative;
  height: 30%;
  img {
    width: 100%;
    max-width: 200px;
    height: auto;
    position: absolute;
    left: 10%;
    &:first-child {
      left: 40%;

      @screen md {
        left: 48%;
      }
    
    }
    &:last-child {
      @screen md {
        left: 38%;
      }   
     }    
  }
}

.pointer {
   width: 64px;
  height: 64px; 
}

.knd-header__left {
  max-width: 600px;
}

.header-title__wrapper {
  height: 100vh;
  display: flex;
  align-items: center;
  position: relative;
  .header__title { }
}

.pic__info {
  position: absolute;
  bottom: 0;
  text-align: left;
  background: #FFF;
  right: 0;
  left: 0;
}

.knd-login__wrapper {
  height: 100vh;
}

.nope-pointer,
.like-pointer {
  position: absolute;
  z-index: 1;
  top: 20px;
  width: 64px;
  height: 64px;
}

.nope-pointer {
  right: 10px;
}

.like-pointer {
  left: 10px;
}

.super-pointer,
.down-pointer {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  margin: auto;
  width: 112px;
  height: 78px;
}

.super-pointer {
  bottom: 40px;
}

.down-pointer {
  top: 40px;
}


.rewind-pointer {
  position: absolute;
  z-index: 1;
  top: 20px;
  right: 10px;
  width: 112px;
  height: 78px;
}

.pic {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.btns {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 50px;
  margin: auto;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 300px;
  max-width: 355px;
}

.btns img {
  margin-right: 12px;
  border-radius: 50%;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.icon-match_scroll {
  margin: 0 auto;
  width: 40px;
}

</style>